<template>
	<v-container class="biography none-fluid link">
		<banner>Biography</banner>
		<br />
		<div class="mx-auto biography-content">
            <img :src="image" style="float:left; margin: 70px 50px 50px 0px; width:300px" alt="Maja Matari&#263;">
			<br />
			<br />
            <div class="sub-title">
                <div v-html="$sanitize(title)"></div>
                <div class="sub-sub-title">
                   <div v-html="$sanitize(subtitle)"></div>
                </div>
            </div>
            <br />
			<br />
			<div v-html="$sanitize(bio)"></div>
			<br />
			<br />
			
		</div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import {
	getBiography
} from "../../service/about/biography";

export default {
	components: {
		Banner
	},
	data() {
		return {
			image: {},
			title: "",
			bio: "",
            subtitle:""
		};
	},
	mounted() {
		getBiography()
			.then(biography => {
				this.image = biography.image;
                this.bio = biography.bio;
                this.title = biography.title;
                this.subtitle = biography.subtitle
            })
			.catch(err => {
				console.error(err.message);
			});
		
	}
};
</script>

<style lang="scss">
.sub-title {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 24px;
  letter-spacing: 1px;
  padding-top: 10px;
}

.sub-sub-title {
  font-size: 16px;
  font-style: italic;
  padding-top: 10px;
}

.biography {
	.biography-content {
		.biography-image {
			max-width: 950px;
			width: 100%;
			display: block;
			margin-left: auto;
			margin-right: auto;
		}

		.google-map {
			position: relative;
		}
	}
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.contact {
		.contact-content {
			.google-map {
				position: relative;
				width: 100% !important;
				height: 300px !important;
			}
		}
	}
}
</style>
